import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const getters = {
  SHOW: (state: any) => {
    return state.show
  },
}

const actions = {}

const mutations = {
  SHOW (context: any, show) {
    context.show = show
  },
}

export default new Vuex.Store({
  state: {
    show: true,
  },
  getters: getters,
  actions: actions,
  mutations: mutations,
})
